export const SIDEBAR_SETTINGS_CONTENT_TYPE = 'settings';
export const SIDEBAR_ADD_PROJECT_CONTENT_TYPE = 'add-project';
export const SIDEBAR_MANAGE_PROJECTS_CONTENT_TYPE = 'manage-projects';
export const SIDEBAR_MANAGE_FILTERS_CONTENT_TYPE = 'manage-filters';
